import React from "react";
import PropTypes from "prop-types";
import useViewport from "../../Helpers/hooks/useViewport";

/**
 * Wrapper that puts a 50 50 columns on desktop
 * @returns JSX component
 */
export const DesktopGrid = ({ leftSide, rightSide, className = "" }) => {
    const { isDesktop } = useViewport();
    if (!isDesktop) {
        return (
            <>
                {leftSide}
                {rightSide}
            </>
        );
    }

    return (
        <div className={`grid_container ${className}`}>
            <div>{leftSide}</div>
            <div>{rightSide}</div>
        </div>
    );
};

DesktopGrid.propTypes = {
    leftSide: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    rightSide: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    className: PropTypes.string,
};
